import React, {PureComponent} from 'react';

import LandingFreelance from './LandingFreelanceUniverse.jsx';

import header from './images/header-purchase.png?size=600';

const metaDescription = "Accédez à des missions en achats : directs, indirects et projets... Un accompagnement personnalisé et des projets adaptés à votre expertise. Découvrez nos offres.";
const metaTitle = "Twineeds | Missions Achats et Supply | Consultants Indépendants";

export default class LandingFreelancePurchase extends PureComponent {
  render() {
    return (
      <LandingFreelance
        headerImg={header.src}
        headerImgAlt="PC et portable montrant un site d'intermédiation pour consultants freelances et entreprise"
        metaDescription={metaDescription}
        metaOgDescription={metaDescription}
        metaTitle={metaTitle}
        metaOgTitle={metaTitle}
        sectorText="des achats"
        title="Mandats pour professionnels des Achats et Supply Chain"
        universeCode="purchase"
      />
    );
  }
}
